import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from '../sections/auth/ProtectedRoute';
import DailyAttendance from '../pages/Reports/AttendanceReport/DailyAttendance';
//import StockList from '../pages/Reports/StockVerification/StockList';
//import UploadStock from '../pages/Reports/StockVerification/UploadStock';
//import FarmerForm from '../pages/MasterData/FarmerMaster/FarmerForm';
//import RetailerForm from '../pages/MasterData/RetailerMaster/RetailerForm';
import DistributorForm from '../pages/MasterData/DistributorMaster/DistributorForm';
import ExpenseApprovalNew from '../pages/NewApprovals/ExpenseApprovalNew';

const Gallery = lazy(() => import('../pages/Documents/Gallery'));
const TravelUpdate = lazy(() => import('../pages/Reports/TravelUpdate/TravelUpdate'));
const AdminApproval = lazy(() => import('../pages/Approvals/AdminApproval'));
const CompanyList = lazy(() => import('../pages/IAM/Company/CompnayList'));
// const IamList = lazy(() => import('../pages/Admin-IAM/IAM/IamList'));
const RegionList = lazy(() => import('../pages/MasterData/RegionMaster/RegionList'));
const TerritoryList = lazy(() => import('../pages/MasterData/TerritoryMaster/TerritoryList'));
const RegionForm = lazy(() => import('../pages/MasterData/RegionMaster/RegionForm'));
const TerritoryForm = lazy(() => import('../pages/MasterData/TerritoryMaster/TerritoryForm'));

// render - Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// User Master
const EmployeeList = Loadable(lazy(() => import('pages/UserMaster/EmployeeMaster/EmployeeList')));
const EmployeeFormPage = Loadable(lazy(() => import('pages/UserMaster/EmployeeMaster/EmployeeFormPage')));
const MdoList = Loadable(lazy(() => import('pages/UserMaster/MdoMaster/MdoList')));
const MdoForm = Loadable(lazy(() => import('pages/UserMaster/MdoMaster/MdoForm')));

// Master Data
const DistributorList = Loadable(lazy(() => import('pages/MasterData/DistributorMaster/DistributorList')));
const FarmerList = Loadable(lazy(() => import('pages/MasterData/FarmerMaster/FarmerList')));
const RetailerList = Loadable(lazy(() => import('pages/MasterData/RetailerMaster/RetailerList')));
const ProductList = Loadable(lazy(() => import('pages/MasterData/ProductMaster/ProductList')));
const ProductForm = Loadable(lazy(() => import('pages/MasterData/ProductMaster/ProductForm')));
const LocationMaster = Loadable(lazy(() => import('pages/MasterData/LocationMaster/LocationMaster')));

// Reports
const AttendanceReport = Loadable(lazy(() => import('pages/Reports/AttendanceReport/AttendanceReport')));
const ExpenseReport = Loadable(lazy(() => import('pages/Reports/ExpenseReport/ExpenseReport')));
const TravelReport = Loadable(lazy(() => import('pages/Reports/TravelReport/TravelReport')));
const ActivityReport = Loadable(lazy(() => import('pages/Reports/ActivityReport/ActivityReport')));
const LiveActivityMap  = Loadable(lazy(() => import('pages/Reports/LiveActivityMap/LiveActivityMap')));
// Approvals
const ExpenseApproval = Loadable(lazy(() => import('pages/Approvals/ExpenseApproval')));
const L2ExpenseApproval = Loadable(lazy(() => import('pages/Approvals/L2ExpenseApproval')));

// Query
const CustomerComplaint = Loadable(lazy(() => import('pages/Query/CustomerComplaint/CustomerComplaint')));

// Orders
const SalesOrderApproval = Loadable(lazy(() => import('pages/Orders/SalesOrderApproval/SalesOrderApproval')));

// IAM
const AddCompany = Loadable(lazy(() => import('pages/IAM/Company/AddCompanies')));
const MenuList = Loadable(lazy(() => import('pages/IAM/MenuSubmenuList/MenuList')));
const SubmenuList = Loadable(lazy(() => import('pages/IAM/MenuSubmenuList/SubmenuList')));
// const AddMenu = Loadable(lazy(() => import('pages/IAM/AddMenuSubmenu/AddMenu')));
const AddSubmenu = Loadable(lazy(() => import('pages/IAM/AddMenuSubmenu/AddSubMenu')));
const AssignCompanyMenu = Loadable(lazy(() => import('pages/IAM/AssignCompanyMenu/AssignCompanyMenu')));
const AssignRoleMenu = Loadable(lazy(() => import('pages/IAM/Role-wiseMenuAccess/AssignRoleMenu')));
// ==============================|| MAIN ROUTING ||============================== //
const DistributorRequestForm = Loadable(
  lazy(() => import('pages/Distributor/DistributorRequest'))
);

const DistributorRequestFormAdmin = Loadable(
  lazy(() => import('pages/Distributor/DistributorRequestAdmin'))
);

const NewApprovalL1 = Loadable(
  lazy(() => import('pages/NewApprovals/ExpenseApprovalNew'))
);

const StockReport = Loadable(
  lazy(() => import('pages/Reports/StockReport/StockReport'))
);
const ApprovedExpenseReport = Loadable(
  lazy(() => import('pages/Reports/ExpenseReport/ApprovedExpenseReport'))
);
const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: '/employee-master',
      element: <EmployeeList />
    },
    {
      path: '/add-employee',
      element: <EmployeeFormPage />
    },
    {
      path: '/third-party',
      element: <MdoList />
    },
    {
      path: '/add-mdo',
      element: <MdoForm />
    },
    {
      path: '/distributor-master',
      element: <DistributorList />
    },
    {
      path: '/retailer-master',
      element: <RetailerList />
    },
    {
      path: '/farmer-master',
      element: <FarmerList />
    },
    {
      path: '/product-master',
      element: <ProductList />
    },
    {
      path: '/location-master',
      element: <LocationMaster />
    },
    {
      path: '/region-master',
      element: <RegionList />
    },
    {
      path: '/add-region',
      element: <RegionForm />
    },
     {
      path: '/add-territory',
      element: <TerritoryForm />
    },
     {
      path: '/territory-master',
      element: <TerritoryList />
    },
    {
      path: '/add-product',
      element: <ProductForm />
    },
    {
      path: '/expense-report',
      element: <ExpenseReport />
    },
    {
      path: '/travel-update',
      element: <TravelUpdate />
    },
    {
      path: '/approved-expense-report',
      element: <ApprovedExpenseReport />
    },
    {
      path: '/travel-report',
      element: <TravelReport />
    },
    {
      path: '/activity-report',
      element: <ActivityReport />
    },
    {
      path: '/expense-approval',
      element: <ExpenseApproval />
    },
    {
      path: '/expense-approval-new',
      element: <NewApprovalL1 />
    },
     {
       path: '/l2expense-approval',
       element: <L2ExpenseApproval />
     },
    {
      path: '/admin-expense-approval',
      element: <AdminApproval />
    },
     {
      path: '/handbook',
      element: <Gallery />
    },
     {
      path: '/request-update',
      element: <CustomerComplaint />
    },
    {
      path: '/sales-order-approval',
      element: <SalesOrderApproval />
    },
      {
      path: '/distributor-request',
      element: <DistributorRequestForm />
    },
    {
      path: '/distributor-request-admin',
      element: <DistributorRequestFormAdmin />
    },
    {
      path: '/daily-attendance',
      element: <DailyAttendance />
    },
     {
       path: '/stock-verification',
       element: <StockReport />
     },
    // {
    //   path: '/upload-stock',
    //   element: <UploadStock />
    // },
    // {
    //   path: '/add-farmer',
    //   element: <FarmerForm />
    // },
    // {
    //   path: '/add-retailer',
    //   element: <RetailerForm />
    //},
    { path: '/add-distirbutor',
      element: <DistributorForm/>
    },
    { path: '/live-activity-map',
      element: <LiveActivityMap/>
    },
    {
      path: '/add-company',
      element: <AddCompany />
    },
     {
      path: '/company',
      element: <CompanyList />
    },
     {
  path: "/menu",
  element: <MenuList />
},
{
  path: "/submenu",
  element: <SubmenuList />
},

{
  path: "/add-submenu",
  element: <AddSubmenu />
},
{
  path: "/assign-company-menu",
  element: <AssignCompanyMenu />
},
{
  path: "/assign-role-menu",
  element: <AssignRoleMenu />
},
    //  {
    //   path: '/company',
    //   element: <CompanyList />
    // },
    //  {
    //   path: '/iam',
    //   element: <IamList />
    // },
  ]
};

export default MainRoutes;
